import { Box, ITheme, Typography, useTheme } from '@mui/material';
import React from 'react';
import { Utilities } from '../../utility/utils';
import { LeoImagesSectorsPath } from '../../resources/api-constants';
import { useTranslation } from 'react-i18next';

export interface ILeoTagProps{
    icon?: string;
    text: string;
    value?: number;
    size?: 'small' | 'medium';
}

const LeoTag: React.FC<ILeoTagProps> = ({ icon, text, value, size }) => {
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();
    
    return <Box display={"flex"} bgcolor={theme.palette.common.white} className={`sector-tag ${Utilities.toClassName(text)}`} padding={`${size === 'medium' ? "10px" : "4px"} 10px`} borderRadius={"4px"} alignItems={"center"} gap={"8px"}>
        {icon && <img src={`${LeoImagesSectorsPath}/${icon}`} alt={`${t('A11ySectorAlt')} ${text}`} />}
        <Typography fontSize={"14px"} lineHeight={"14px"} fontWeight={"500"} color={theme.palette.common.white}>{text}</Typography>
        {value !== undefined && <Box bgcolor={theme.palette.common.white} borderRadius={"8px"} padding={`0 6px`}>
            <Typography fontSize={"12px"} lineHeight={"16px"} fontWeight={"500"} color={theme.palette.leo.type[600]}>{(value * 100).toFixed(0)}%</Typography>
        </Box>}
    </Box>;
}

export default LeoTag;